import React,{Component} from 'react';

import './Throughput.css';

import { background_2, image2 } from '../../theme/images';
import Page from '@acri-tools/react-tools/components/Page/Page';
import Tabs from '@acri-tools/react-tools/components/Tabs/Tabs';
import Counters from '../../components/Counters/Counters';
import { axiosErrorHandler, toast_request_error } from '@acri-tools/react-tools/utils/global';
import request from '@acri-tools/react-tools/utils/request';

import { get_data_file_url, get_text_counter } from '../../utils/data';
import WeeklyStatistics from './content/WeeklyStatistics/WeeklyStatistics';
import { Helmet } from 'react-helmet';
import { get_page_title } from '../../utils/config';

interface Props{
}
interface State{
    loading: boolean,
    data? :any,
    loading_counters: boolean,
    counter_data? :any,
}



export default class Throughput extends Component<Props,State>{
    constructor(props:Props){
        super(props);
        this.state = {
            loading: false,
            loading_counters: false,
        }
    }

    componentDidMount(){
        this.fetch_data();
        this.fetch_counter_data();
    }
    
    fetch_counter_data = async () => {
        this.setState({ loading_counters: true });
        try {
            let res = await request(get_data_file_url(`live_th.json`), { method: 'get' })

            this.setState({ counter_data: res.data });
        }
        catch (e) {
            axiosErrorHandler(e, { functionName: `fetch_counter_data` });
            toast_request_error(e);
        }
        finally {
            this.setState({ loading_counters: false })
        }
    }
    fetch_data = async () => {
        this.setState({ loading: true });
        try {
            let res = await request(get_data_file_url(`live_data_rate_chart.json`), {
                method: 'get'
            })

             console.debug("data", res.data);


            this.setState({ data: res.data });
        }
        catch (e) {
            axiosErrorHandler(e, { functionName: `fetch_data` });
            toast_request_error(e);
        }
        finally {
            this.setState({ loading: false })
        }
    }

    render(){
        let tabs = [
            {
                label: <>Weekly Statistics</>,
                content: <div className="throughput-content">
                    <WeeklyStatistics data={this.state.data} loading={this.state.loading}/>
                </div>
            },
        ]

        return (
        <Page 
            id="throughput"
            banner={{
                title: "throughput",
                bannerImage: background_2,
                topBar: true
            }}
            footer
        >
            <Helmet>
                <title>{ get_page_title(`DAMPS - Throughput`) }</title>
                <meta 
                    name="description" 
                    content="DAMPS throughput details"
                />
            </Helmet>
            <div className="page-content">
                <div className="centered-content padding">
                    <Counters
                        counters={[
                            get_text_counter("MEAN throughput over the last week", this.state.counter_data?.week, this.state.loading_counters),
                            get_text_counter("MEAN throughput over the 4 weeks", this.state.counter_data?.['4week'], this.state.loading_counters),
                        ]}
                    />
                </div>
                <div className="centered-content padding">
                    <Tabs tabs={tabs}/>
                </div>
            </div>
        </Page>
        );
    }


};
